// @ts-nocheck
import { IValidatorFunction, required } from "@origin-digital/validation";

import { AddressManualEntryValues } from "./models";

export const notEmpty = (value: string): boolean =>
  value !== "" && value !== undefined;

export const reduceValidators = (
  currentValue: string,
  allValues: AddressManualEntryValues,
  validators: IValidatorFunction[]
): string =>
  validators.reduce<string>((errorMessage, validator) => {
    if (errorMessage) {
      return errorMessage;
    }

    return validator(currentValue, allValues as any) || "";
  }, "");

export const validUnitType =
  ({ error }) =>
  (currentValue: string, { unitNumber }: AddressManualEntryValues) => {
    if (notEmpty(unitNumber)) {
      return required({ error })(currentValue);
    }
  };

export const validUnitNumber =
  ({ error }) =>
  (currentValue: string, { unitType }: AddressManualEntryValues) => {
    if (notEmpty(unitType)) {
      return required({ error })(currentValue);
    }
  };
